import React, { Component, Fragment } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Modal, Radio, Spin } from 'hljd'
import { observer } from 'mobx-react'
import store from '../../store'
import FormGallery from '@common/FormGallery'
import { REGEX_EMAIL, REGEX_PHONE } from '@constant'

const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const FormItem = Form.Item

const layout = {
  labelCol: {
    span: 4
  },
  wrapperCol: {
    span: 16
  }
}

@Form.create()
@observer
export default class extends Component {
  save = e => {
    e.preventDefault()

    const {
      record: { from_pixiu, company_type, id }
    } = store

    this.props.form.validateFields((err, values) => {
      if (!err) {
        store.saveInvoice({
          [from_pixiu === 1 ? 'pixiu_order_id' : 'order_id']: id,
          kind: company_type,
          ...values
        })
      }
    })
  }

  changeCompanyType = value => {
    if (value == 1) {
      this.props.form.setFieldsValue({ invoice_kind: '1' })
      store.changeInvoiceType('1')
    }

    store.changeCompanyType(value)
  }

  render() {
    const {
      closeApplyModal,
      applyModalVisible,
      applyRecord,
      company_type,
      invoice_type,
      changeInvoiceType,
      modalLoading,
      applyImages,
      saveLoading
    } = store
    const { getFieldDecorator } = this.props.form

    const {
      kind,
      invoice_kind,
      title,
      identifier,
      address,
      contact_mobile,
      bank,
      bank_no,
      email,
      phone,
      shop_address,
      images
    } = applyRecord

    return applyModalVisible ? (
      <Modal
        title="发票信息"
        visible={applyModalVisible}
        onOk={this.save}
        onCancel={closeApplyModal}
        width={800}
        okButtonProps={{ loading: saveLoading }}
      >
        <Spin spinning={modalLoading}>
          <Form>
            <FormItem {...layout} label="公司类型">
              {getFieldDecorator('kind', {
                initialValue: kind || '1',
                rules: [
                  {
                    required: true
                  }
                ]
              })(
                <RadioGroup
                  onChange={e => this.changeCompanyType(e.target.value)}
                >
                  <RadioButton value="1">个人</RadioButton>
                  <RadioButton value="2">企业</RadioButton>
                </RadioGroup>
              )}
            </FormItem>

            <FormItem {...layout} label="发票类型">
              {getFieldDecorator('invoice_kind', {
                initialValue: invoice_kind || '1',
                rules: [
                  {
                    required: true
                  }
                ]
              })(
                <RadioGroup onChange={e => changeInvoiceType(e.target.value)}>
                  <RadioButton value="1">普通电子发票</RadioButton>

                  {company_type == 2 && (
                    <RadioButton value="2">增值税专用发票</RadioButton>
                  )}
                </RadioGroup>
              )}

              {invoice_type == 1 ? (
                <p>
                  电子普通发票是税局认可的有效凭证，其法律效力、基本用途及使用规定同纸质发票
                </p>
              ) : (
                <p>
                  只有一般纳税人才可开具，请确保增票资质信息与贵司税务登记证信息一致
                </p>
              )}
            </FormItem>

            <FormItem {...layout} label="发票抬头">
              {getFieldDecorator('title', {
                initialValue: title,
                rules: [
                  {
                    required: true,
                    message: '请填写个人或姓名'
                  }
                ]
              })(<Input placeholder="请填写个人或姓名" />)}
            </FormItem>

            {company_type == 2 && (
              <Fragment>
                <FormItem {...layout} label="纳税人识别号">
                  {getFieldDecorator('identifier', {
                    initialValue: identifier,
                    rules: [
                      {
                        required: true,
                        message: '请填写税务登记证上的编号'
                      }
                    ]
                  })(<Input placeholder="请填写税务登记证上的编号" />)}
                </FormItem>

                {invoice_type == 2 && (
                  <Fragment>
                    <FormItem {...layout} label="注册场所地址">
                      {getFieldDecorator('address', {
                        initialValue: address,
                        rules: [
                          {
                            required: true,
                            message: '请填写营业执照上的注册地址'
                          }
                        ]
                      })(<Input placeholder="请填写营业执照上的注册地址" />)}
                    </FormItem>
                    <FormItem {...layout} label="注册固定电话">
                      {getFieldDecorator('contact_mobile', {
                        initialValue: contact_mobile,
                        rules: [
                          {
                            required: true,
                            message: '请输入注册电话'
                          }
                        ]
                      })(<Input placeholder="请输入注册电话" />)}
                    </FormItem>
                    <FormItem {...layout} label="开户银行名称">
                      {getFieldDecorator('bank', {
                        initialValue: bank,
                        rules: [
                          {
                            required: true,
                            message: '请填写开户许可证上的开户银行'
                          }
                        ]
                      })(<Input placeholder="请填写开户许可证上的开户银行" />)}
                    </FormItem>
                    <FormItem {...layout} label="开户银行卡号">
                      {getFieldDecorator('bank_no', {
                        initialValue: bank_no,
                        rules: [
                          {
                            required: true,
                            message: '请填写开户许可证上的银行账号'
                          }
                        ]
                      })(<Input placeholder="请填写开户许可证上的银行账号" />)}
                    </FormItem>
                    <FormItem
                      {...layout}
                      label={
                        <Fragment>
                          <span>合同照片</span>
                          <br />
                          <span>{applyImages.length}/9</span>
                        </Fragment>
                      }
                    >
                      {getFieldDecorator('images', {
                        initialValue:
                          images === 'null' || !images
                            ? JSON.parse('[]')
                            : JSON.parse(images),
                        rules: [
                          {
                            required: true,
                            message: '请上传合同照片'
                          }
                        ]
                      })(
                        <FormGallery
                          keyField="img"
                          max={9}
                          multiple={true}
                          onChange={val => {
                            store.applyImages = val
                          }}
                        />
                      )}

                      <p style={{ fontSize: 14, color: 'red' }}>
                        请上传已加盖双方公章的合同照片，并保证合同主体与发票抬头一致，且已将纸质合同寄回婚礼纪财务部存档
                      </p>
                    </FormItem>
                  </Fragment>
                )}
              </Fragment>
            )}

            <FormItem {...layout} label="收票人手机">
              {getFieldDecorator('phone', {
                initialValue: phone,
                rules: [
                  {
                    required: true,
                    message: '请填写收票人手机'
                  },
                  {
                    pattern: REGEX_PHONE,
                    message: '请填写正确的手机格式'
                  }
                ]
              })(<Input placeholder="开好发票通知您" />)}
            </FormItem>

            {invoice_type == 1 && (
              <FormItem {...layout} label="收票人邮箱">
                {getFieldDecorator('email', {
                  initialValue: email,
                  rules: [
                    {
                      required: true,
                      message: '请填写收票人邮箱'
                    },
                    {
                      pattern: REGEX_EMAIL,
                      message: '请填写正确的邮箱格式'
                    }
                  ]
                })(<Input placeholder="用于接收电子发票" />)}
              </FormItem>
            )}

            {invoice_type == 2 && (
              <FormItem {...layout} label="收票地址">
                {getFieldDecorator('shop_address', {
                  initialValue: shop_address,
                  rules: [
                    {
                      required: true,
                      message: '请填写收票地址'
                    }
                  ]
                })(<Input placeholder="请填写收票地址" />)}
              </FormItem>
            )}
          </Form>
        </Spin>
      </Modal>
    ) : null
  }
}
